import { combineReducers } from 'redux';
import userReducer from './user/reducer_user';
import groupsReducer from './groups/reducer_groups';


const rootReducer = combineReducers({
    user: userReducer,
    groups: groupsReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js